import React from 'react'
import styled from 'styled-components'

export const styledWithProp = (Component, propName) => {
  // eslint-disable-next-line
  function ConvertPropName({ className, ...props }) {
    return React.createElement(Component, { [propName]: className, ...props })
  }

  const StyledComponent = styled(ConvertPropName)

  return StyledComponent
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/hoc/styledWithProp.js